
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Autocomplete, Button, Grid, MenuItem, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { startSavingProveedor } from "../../../../services";
import { useCiudadesStore } from "../../../../store";

import Swal from "sweetalert2";




export const FormCreateUpdateProveedor = ({ initialState }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { startListadoCiudades, ciudades, startListadoRegiones, regiones } = useCiudadesStore();
    const [formProveedor, setFormProveedor] = useState( initialState );
    const { nombre, email, nit, formaPago, diasCredito, departamento, ciudad, movil, direccion } = formProveedor;

    
    useEffect(() => {
        startListadoRegiones();
    }, [])


    const  handleInputChange = ({ target }) => {
        setFormProveedor({
            ...formProveedor,
            [target.name]: target.value
        });
    }


    const handleChangeRegion = async (nombre) => {
        await startListadoCiudades(nombre);
        setFormProveedor(prev => ({ ...prev, departamento: nombre })); 
    };

    

    const crearActInformacion = async(e) => {
        e.preventDefault();
        const isUpdate = (id != 'new') ? id : null;
        if([nombre, email, nit, formaPago, diasCredito, departamento, ciudad, movil, direccion].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }

        const result = await Swal.fire({
            title: `${(isUpdate) ? 'Actualizar' : 'Crear'} Proveedor`,
            text: `¿Esta seguro de ${(isUpdate) ? 'Actualizar' : 'Crear'} Proveedor?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si ${(id) ? 'Actualizar' : 'Crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingProveedor({ ...formProveedor, id: isUpdate });
        if(resp){
            if(!isUpdate) { 
                setFormProveedor(initialState); 
            }else {
                queryClient.invalidateQueries({queryKey: ['proveedor-id', id]});
            }
            queryClient.invalidateQueries({queryKey: ['proveedores-list']});
        }
    }



    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nombre'
                        type='text'
                        placeholder='Nombre'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Correo'
                        type='text'
                        placeholder='Email'
                        fullWidth
                        name='email'
                        value={ email }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nit'
                        type='text'
                        placeholder='Nit'
                        fullWidth
                        name='nit'
                        value={ nit }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Telefono'
                        type='text'
                        placeholder='Telefono'
                        fullWidth
                        name='movil'
                        value={ movil }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                    select
                    label="Forma de Pago"
                    fullWidth
                    name='formaPago'
                    value={ formaPago }
                    onChange={ handleInputChange }
                >
                        <MenuItem value=''>Seleccione Forma de Pago</MenuItem>
                        <MenuItem value='CREDITO'>CREDITO</MenuItem>
                        <MenuItem value='CONTADO'>CONTADO</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Dias Credito'
                        type='number'
                        placeholder='Dias Credito'
                        fullWidth
                        name='diasCredito'
                        value={ diasCredito }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Direccion'
                        type='text'
                        placeholder='Direccion'
                        fullWidth
                        name='direccion'
                        value={ direccion }
                        onChange={ handleInputChange }
                    />
                </Grid>

                {(regiones.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        name='departamento'
                        value={ regiones?.find(p => p.id === departamento) || null }
                        options={ regiones || [] }
                        onChange={(_, newValue) => handleChangeRegion(newValue.id)}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Departamento' />}
                        getOptionLabel={(option) => option.name }
                        placeholder="Departamento"
                    />
                </Grid>
                }

                {(ciudades.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        name='ciudad'
                        value={ ciudades?.find(p => p.id === ciudad) || null }
                        options={ ciudades || [] }
                        onChange={(_, newValue) => handleInputChange({ target:{name: 'ciudad', value: newValue.id || ''}})}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Ciudad' />}
                        getOptionLabel={(option) => option.name }
                        placeholder="Ciudad"
                    />
                </Grid>
                }

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${(id != 'new') ? 'Actualizar' : 'Crear'} Proveedor`}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}
